// extracted by mini-css-extract-plugin
export default {"title":"HeaderLogo_title__9BR6y"};